@if (discipline === 'PICKLEBALL' || discipline === 'BADMINTON' || discipline === 'TABLE_TENNIS' || discipline === 'SQUASH') {
  @if (playerCellType === 'official-view') {
    <div>
      <app-pickleball-court
      [topLeftPlayer]="getPlayerNameTopLeft()"
      [bottomLeftPlayer]="getPlayerNameBottomLeft()"
      [topRightPlayer]="getPlayerNameTopRight()"
      [bottomRightPlayer]="getPlayerNameBottomRight()"
      [serverNumber]="point?.server?.serverNumber"
      [returningSide]="point?.server?.returningSide"
      [areSidesReveresed]="areSidesReveresed"
      [matchStatus]="matchStatus"
      [discipline]="discipline"
      [server]="point?.server"
      [matchType]="matchType"
      [point]="point"
    ></app-pickleball-court>
    </div>
  } @else {
    <div class="container">
      <div class="left-column">
        <div class="row" style="display: flex;">
          <app-player-cell
            [player]="getPlayerNameTopLeft()"
            [returningSide]="point.server?.returningSide"
            [returningSideType]="discipline === 'SQUASH' ? 'DEUCE' : 'AD'"
            [serverNumber]="point.server?.serverNumber"
            [type]="playerCellType">
          </app-player-cell>

          <app-player-cell
            [player]="getPlayerNameTopRight()"
            [returningSide]="point.server?.returningSide"
            [returningSideType]="'DEUCE'"
            [serverNumber]="point.server?.serverNumber"
            [type]="playerCellType">
          </app-player-cell>
        </div>
        <div class="row">
          <app-player-cell
            [player]="getPlayerNameBottomLeft()"
            [returningSide]="point.server?.returningSide"
            [returningSideType]="discipline === 'SQUASH' ? 'AD' : 'DEUCE'"
            [serverNumber]="point.server?.serverNumber"
            [type]="playerCellType">
          </app-player-cell>

          <app-player-cell
            [player]="getPlayerNameBottomRight()"
            [returningSide]="point.server?.returningSide"
            [returningSideType]="'AD'"
            [serverNumber]="point.server?.serverNumber"
            [type]="playerCellType">
          </app-player-cell>
        </div>
      </div>

      @if (showScore) {
        <div class="right-column">
          @if (point.winningSide) {
            <div class="row">
              {{ getScore(point.side1Score) }}-{{ getScore(point.side2Score) }}
            </div>
            @if (point.server.serverNumber === 2 && point.winningSide !== point.server.sideNumber) {
              <div class="row">
                <span class="sideout">sideout</span>
              </div>
            }
          }
        </div>
      }
    </div>
  }
} @else {
  <ion-row class="score-list-row ion-text-center" [ngClass]="{'game-row': isGameRow}">
    <!-- Point outcome -->
    <ion-col size="1">
        {{ getOfficialSign(1) }}
    </ion-col>

    <!-- Server -->
    <ion-col size="3" class="ion-text-left">
      @if(isServer(1)) {
        <ion-icon class="icon-as-text" name="tennisball"></ion-icon>@if (point.shots[0]?.shotOutcome === 'FOOT_FAULT') { <sup>F</sup> }
        @if(isFirstServeMissed()) {
          <ion-icon class="icon-as-text" name="tennisball"></ion-icon>@if (point.shots[1]?.shotOutcome === 'FOOT_FAULT') { <sup>F</sup> } {{ isViolation(1) }}
        }
      }

    </ion-col>

    <!-- Score -->
    <ion-col>
      @if(!isGameRow) {
        {{ getScore(point.side1Score) }} - {{ getScore(point.side2Score) }}
      } @else {
        <span [hidden]="isBeginningOfGame()">
          {{ game.side1Score }} - {{ game.side2Score }}
        </span>

        <span [hidden]="!isBeginningOfGame()">
          Game {{ sets[selectedSet - 1].games.length }}
        </span>
      }

    </ion-col>


    <!-- Server -->
    <ion-col size="3" class="ion-text-right">
      {{ isViolation(2) }}
      @if(isServer(2)) {
        <ion-icon  class="icon-as-text" name="tennisball"></ion-icon>@if(point.shots[0]?.shotOutcome === 'FOOT_FAULT') { <sup>F</sup> }
        @if(isFirstServeMissed()) {
          <ion-icon class="icon-as-text" name="tennisball"></ion-icon>@if (point.shots[1]?.shotOutcome === 'FOOT_FAULT') { <sup>F</sup> }
        }
      }
    </ion-col>

    <ion-col size="1">
        {{ getOfficialSign(2) }}
    </ion-col>

  </ion-row>
}